import Container from "@/common/Layout/Container/Container";
import Footer from "@/common/Layout/Footer";
import useTrans from "@/hooks/useTrans";
import { Breadcrumbs, Grid, SimpleGrid, Text } from "@mantine/core";
import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";

export default function ProfileLayout({ children }) {
  // const size = useWindowSize();
  const trans = useTrans();
  const route = [
    {
      title: trans?.profile.layout.info,
      href: "/user-profile/my-profile",
    },
    {
      title: trans?.profile.layout.address,
      href: "/user-profile/address-book",
    },
    {
      title: trans?.profile.layout.purchase,
      href: "/user-profile/purchased-return",
    },
    {
      title: trans?.profile.layout.liked,
      href: "/user-profile/liked-product",
    },
    // {
    //   title: "Thông báo của tôi",
    //   href: "/user-profile/notifycations",
    // },
  ];
  const { pathname } = useRouter();
  const [routes, setRoutes] = React.useState([
    { title: trans?.profile.layout.home, href: "/" },
    { title: trans?.profile.layout.title, href: "/user-profile" },
  ]);

  React.useEffect(() => {
    const state = [
      { title: trans?.profile.layout.home, href: "/" },
      { title: trans?.profile.layout.title, href: "/user-profile" },
    ];
    route.map((item) => {
      pathname.indexOf(item.href) >= 0 && state.push(item);
    });
    setRoutes(state);
  }, [pathname]);

  return (
    <Container>
      <div style={{ padding: "20px 0px" }}>
        <Breadcrumbs>
          {routes?.map((item, index) => (
            <Link scroll={false} href={item.href} key={index}>
              <a>{item.title}</a>
            </Link>
          ))}
        </Breadcrumbs>

        <Grid sx={{ padding: "30px 0px" }}>
          <Grid.Col xs={3}>
            <SimpleGrid cols={1}>
              <Link scroll={false} href="/user-profile" sx={{}}>
                <Text
                  transform="uppercase"
                  weight={pathname === "/user-profile" ? 700 : 500}
                  sx={{ cursor: "pointer" }}
                >
                  {trans?.profile.layout.title}
                </Text>
              </Link>
              <Link scroll={false} href="/user-profile/my-profile" sx={{}}>
                <Text
                  transform="uppercase"
                  weight={pathname.indexOf("/my-profile") >= 0 ? 700 : 500}
                  sx={{ cursor: "pointer" }}
                >
                  {trans?.profile.layout.info}
                </Text>
              </Link>
              <Link scroll={false} href="/user-profile/address-book">
                <Text
                  transform="uppercase"
                  weight={pathname.indexOf("/address-book") >= 0 ? 700 : 500}
                  sx={{ cursor: "pointer" }}
                >
                  {trans?.profile.layout.address}
                </Text>
              </Link>
              <Link scroll={false} href="/user-profile/purchased-return">
                <Text
                  transform="uppercase"
                  weight={
                    pathname.indexOf("/purchased-return") >= 0 ? 700 : 500
                  }
                  sx={{ cursor: "pointer" }}
                >
                  {trans?.profile.layout.purchase}
                </Text>
              </Link>
              <Link scroll={false} href="/user-profile/liked-product">
                <Text
                  transform="uppercase"
                  weight={pathname.indexOf("/liked-product") >= 0 ? 700 : 500}
                  sx={{ cursor: "pointer" }}
                >
                  {trans?.profile.layout.liked}
                </Text>
              </Link>
              {/* <Link scroll={false} href={"/user-profile/notifycations"}>
                <Text
                  transform="uppercase"
                  weight={pathname.indexOf("/notifycations") >= 0 ? 700 : 500}
                  sx={{ cursor: "pointer" }}
                >
                  Thông báo của tôi
                </Text>
              </Link> */}
            </SimpleGrid>
          </Grid.Col>
          <Grid.Col xs={9}>{children}</Grid.Col>
        </Grid>
      </div>
    </Container>
  );
}
ProfileLayout.getLayout = function getLayout(page) {
  return (
    <div>
      <main>
        <section>{page}</section>
      </main>
      <Footer />
    </div>
  );
};
